import axios, { AxiosResponse } from 'axios'

import { AddOnId, AddOnRead, AddOnWrite, CropWrite } from '@generated/types'

const BASE_URL = '/api/add-on'

export default {
  async fetchAll(): Promise<AxiosResponse<AddOnRead[]>> {
    return axios.get<AddOnRead[]>(`${BASE_URL}/`)
  },

  async updateAll(data: AddOnWrite[]): Promise<AxiosResponse<AddOnRead[]>> {
    return axios.put(`${BASE_URL}/all/`, data)
  },

  async updateImage(id: AddOnId, data: FormData): Promise<AxiosResponse<AddOnRead>> {
    return axios.put(`${BASE_URL}/${id}/image/`, data)
  },

  async updateCrop(id: AddOnId, data: CropWrite): Promise<AxiosResponse<AddOnRead>> {
    return axios.put(`${BASE_URL}/${id}/crop/`, data)
  },

  async deleteImage(id: AddOnId): Promise<AxiosResponse<AddOnRead>> {
    return axios.delete(`${BASE_URL}/${id}/image/`)
  },
}
